import { HealthcareFacilityLocationSpecialtyCode } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { HealthcareFacilityLocationSpecialty } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   createNumberSchema,
   createObjectSchema,
   createStringSchema,
   createValueObjectSchema,
} from '@dreryk/react-draft';

export type HealthcareFacilityLocationSpecialtyDraft = {
   id: number;
   code: HealthcareFacilityLocationSpecialtyCode;
   name: string;
};
type HealthcareFacilityLocationSpecialtySchemaPart = {
   healthcareFacilityLocationSpecialty: HealthcareFacilityLocationSpecialty;
};

export const healthcareFacilityLocationSpecialtySchema = createObjectSchema<HealthcareFacilityLocationSpecialtySchemaPart>(
   {
      healthcareFacilityLocationSpecialty: createObjectSchema<HealthcareFacilityLocationSpecialty>({
         id: createNumberSchema(),
         // TODO: Naprawić typowanie w react-draft https://dreryk.atlassian.net/browse/DREGAB-26827
         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
         // @ts-ignore
         code: createValueObjectSchema(HealthcareFacilityLocationSpecialtyCode),
         name: createStringSchema(),
      }),
   }
).strict();
